import { Stack } from "@mui/material";
import { useIntl } from "react-intl";
import {
  LOGIN_ERROR_MESSAGE_DESC_1,
  LOGIN_ERROR_MESSAGE_DESC_2,
  LOGIN_ERROR_MESSAGE_DESC_3,
  LOGIN_ERROR_MESSAGE_DESC_4,
} from "../../Constants/LoginConstants";
import {
  StyledErrorCircleIcon,
  StyledErrorMessageStack,
  StyledLoginErrorTypography,
} from "../../Styles/Login/LoginStyles";

/**
 * @description Error message display when the user provide incorrect username and password
 * @returns {ReactNode} Renders the login failed error message  to the user
 */
export const LoginFailedErrorMessage = () => {
  const intl = useIntl();
  return (
    <StyledErrorMessageStack gap={0.5}>
      <Stack>
        <StyledErrorCircleIcon />
      </Stack>
      <Stack>
        <Stack spacing={3}>
          <StyledLoginErrorTypography id={LOGIN_ERROR_MESSAGE_DESC_1}>
            {intl.formatMessage({ id: LOGIN_ERROR_MESSAGE_DESC_1 })}
          </StyledLoginErrorTypography>
          <Stack>
            <StyledLoginErrorTypography id={LOGIN_ERROR_MESSAGE_DESC_2}>
              {intl.formatMessage({ id: LOGIN_ERROR_MESSAGE_DESC_2 })}
            </StyledLoginErrorTypography>
            <StyledLoginErrorTypography id={LOGIN_ERROR_MESSAGE_DESC_3}>
              {intl.formatMessage({ id: LOGIN_ERROR_MESSAGE_DESC_3 })}
            </StyledLoginErrorTypography>
          </Stack>
          <StyledLoginErrorTypography id={LOGIN_ERROR_MESSAGE_DESC_4}>
            {intl.formatMessage({ id: LOGIN_ERROR_MESSAGE_DESC_4 })}
          </StyledLoginErrorTypography>
        </Stack>
      </Stack>
    </StyledErrorMessageStack>
  );
};
